import {
  validateCepRegex,
  validateEmailRegex,
  validatePhone,
} from '@/utils/validates';
import { resetSocialMedia } from '@/validators/resetUsersInfo';
import * as yup from 'yup';

const validateSlugRegex = /^[a-zA-Z0-9_-]+$/g;

export const editInstitutionalPageSchema = yup
  .object()
  .shape({
    slug: yup
      .string()
      .required('O link amigável é obrigatório.')
      .min(3, 'O link amigável deve ter no mínimo 3 caracteres.')
      .matches(validateSlugRegex, 'Digite um link amigável válido')
      .matches(/[a-zA-Z]/, 'Deve conter ao menos uma letra.'),
    slogan: yup.string().max(255, 'Máximo de 255 caracteres'),
    zipcode: yup.string().matches(validateCepRegex, 'Digite um cep válido.'),
    phone: yup
      .string()
      .required('Telefone é um campo obrigatório.')
      .test(
        'is-10-length',
        'Digite um número de telefone válido',
        phone => !(phone && phone.length < 10)
      )
      .test(
        'is-valid-number',
        'Digite um telefone válido',
        async phone =>
          !(
            phone &&
            !(await validatePhone(phone || Array(10).fill('1').join('')))
          )
      ),
    email: yup
      .string()
      .required('Email é um campo obrigatório.')
      .max(80, 'Você excedeu o limite de caracteres no campo e-mail')
      .matches(validateEmailRegex, 'Digite um e-mail válido'),
    number: yup.string().max(255, 'Máximo de 255 caracteres'),
    description: yup.string().max(1024, 'Máximo de 255 caracteres'),
  })
  .concat(resetSocialMedia);

export const createInstitutionalPageSchema = yup.object().shape({
  display_name: yup
    .string()
    .required('O nome da empresa é obrigatório')
    .max(255, 'O nome deve ter no máximo 255 caracteres'),
  slogan: yup
    .string()
    .max(255, 'O slogan deve ter no máximo 255 caracteres')
    .nullable(),
  description: yup
    .string()
    .nullable()
    .max(1024, 'A descrição da empresa deve ter no máximo 1024 caracteres'),
  slug: yup
    .string()
    .required('O link amigável é obrigatório.')
    .max(255, 'O link amigável deve ter no máximo 255 caracteres')
    .min(3, 'O link amigável deve ter no mínimo 3 caracteres.')
    .matches(validateSlugRegex, 'Digite um link amigável válido')
    .matches(/[a-zA-Z]/, 'Deve conter ao menos uma letra.'),
});
